import {
  FilterType,
  buildEmployeePulseEmployeeDatatableFilter,
  useEmployeePulseEmployeeDatatable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { EmployeePulseIcon } from '../../EmployeePulseIcon'

const scoreFilter = (source: ReturnType<typeof useEmployeePulseEmployeeDatatable>) => {
  return buildEmployeePulseEmployeeDatatableFilter(source, {
    title: i18n.t('engagement.pulse.dashboard.datatable.filters.pulse_value'),
    path: 'value',
    identifier: 'value',
    type: FilterType.Integer,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: [
          {
            label: i18n.t('engagement.employee_pulse_labels.1'),
            value: 1,
            component: <EmployeePulseIcon mood={1} withLabel />,
          },
          {
            label: i18n.t('engagement.employee_pulse_labels.2'),
            value: 2,
            component: <EmployeePulseIcon mood={2} withLabel />,
          },
          {
            label: i18n.t('engagement.employee_pulse_labels.3'),
            value: 3,
            component: <EmployeePulseIcon mood={3} withLabel />,
          },
          {
            label: i18n.t('engagement.employee_pulse_labels.4'),
            value: 4,
            component: <EmployeePulseIcon mood={4} withLabel />,
          },
          {
            label: i18n.t('engagement.employee_pulse_labels.5'),
            value: 5,
            component: <EmployeePulseIcon mood={5} withLabel />,
          },
        ],
      },
    ],
  })
}

export default scoreFilter
